import Vue from 'vue'
const request = Vue.prototype.$axios;
const baseUrl = '/dtv/api/next/map/data'
export const getList = (params) => request({
  url: "/dtv/api/next/map/data/get/list/by/condition",
  method: 'get',
  params: params
});



export const getObj = (id) => request({
  url: baseUrl + '/get/by/id',
  method: 'get',
  params: {
    id
  }
});

export const addObj = (data) => request({
  url: baseUrl + '/save',
  method: 'post',
  data: data
});
export const updateObj = (data, method) => request({
  url: baseUrl + '/do/' + method === 'post' ? 'create' : 'update',
  method,
  data
});


export const delObj = (id) => request({
  url: baseUrl + '/do/delete/by/id',
  method: 'delete',
  data: [id]
});

export const getMapData = (id) => request({
  url: baseUrl + '/data',
  method: 'get',
  params: {
    id: id
  }
});
